import React from 'react';

import {Col, Row, Image, InputGroup, Form, Card, Container} from "react-bootstrap";

function Intro() {
    return (
        <div className="bg-body" style={{paddingLeft: 40, paddingRight: 40}}>
            <Row className="justify-content-center" >
                <Col xs={12} sm={10} md={8} lg={6} style={{textAlign: 'center'}}>
                    <Image src={"/images/apple.png"} width={60} />
                    <h3 style={{marginBottom: 20}}>
                    Elevate Your iOS Development with Context-Aware Symbol Suggestions
                    </h3>
                </Col>
            </Row>
        </div>
    );
}

export default Intro;
